import { TestEntity } from '../test.entity';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { inject, Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { ConsumerEntityService } from '../../consumer/services/consumer.entity.service';
import { SubjectEntityService } from '../../subject/services/subject.entity.service';
import { SequenceEntityService } from '../../sequence/services/sequence.entity.service';

export const STATE_NAME = 'testEntity';

export const TestEntityState: GenericEntityStateClass<TestEntity> =
  createEntityState<TestEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class TestEntityService extends EntityService<TestEntity> {
  private consumerEntityService = inject(ConsumerEntityService);
  private subjectEntityService = inject(SubjectEntityService);
  private sequenceEntityService = inject(SequenceEntityService);

  constructor() {
    super();
    this.resourceType = 'tests';
    this.stateClass = TestEntityState;

    this.registerRelation('consumers', this.consumerEntityService);
    this.registerRelation('subjects', this.subjectEntityService);
    this.registerRelation('sequences', this.sequenceEntityService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): TestEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
